<template>
  <Modal title="我的反馈记录" v-model="dialogVisible" width="80%" footer-hide>
    <div class="feedbackRecord">
      <div class="f-item" v-for="(item, index) in feedbackFAQList" :key="index">
        <div class="question">{{ item.question }}</div>
        <div class="answer fjcsb">
          <div class="left">
            <span
              >回复结果：{{
                item.faqStatus
                  ? common.valueToLabel(faqStatusList, item.faqStatus)
                  : "待回复"
              }}</span
            >
            <span class="red" v-if="item.faqStatus == 1">
              <Poptip
                :content="item.answer"
                placement="right-start"
                width="800"
                transfer
                transfer-class-name="utooltip"
                word-wrap
                @on-popper-show="readFAQMsg(item)"
              >
                查看解答
              </Poptip>
            </span>
          </div>
          <div class="right">
            <span>反馈日期：{{ item.questionTime }}</span>
            <span v-if="item.answerTime">回复日期：{{ item.answerTime }}</span>
          </div>
        </div>
      </div>
      <empty v-if="feedbackFAQList.length == 0" />
    </div>
  </Modal>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      feedbackFAQList: [],
      dialogVisible: false,
      faqStatusList: [
        {
          label: "待解答",
          value: "0",
        },
        {
          label: "已解答",
          value: "1",
        },
        {
          label: "不解答",
          value: "2",
        },
      ],
    };
  },
  methods: {
    getData() {
      request.post("/saasbaihui/getFeedbackFAQList").then((res) => {
        this.feedbackFAQList = res.result;
      });
    },
    open() {
      this.dialogVisible = true;
      this.getData();
    },
  },
};
</script>

<style scoped lang="scss">
.feedbackRecord {
  min-width: 400px;
  min-height: 300px;
  max-height: 60vh;
  overflow-y: auto;
  color: #333;
  .f-item {
    border-bottom: 1px dotted #ccc;
    margin-bottom: 15px;
    padding-bottom: 15px;
    .question {
      line-height: 2em;
    }
    .answer {
      margin-top: 10px;
      opacity: 0.8;
      font-size: 13px;
      .left {
        .red {
          cursor: pointer;
          margin-left: 15px;
        }
      }
      .right {
        span {
          margin-left: 20px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.utooltip {
  .ivu-tooltip-inner {
    // width: 800px;
    max-width: 800px;
  }
  .ivu-poptip-body-content-inner {
    max-height: 200px;
    overflow-y: auto;
  }
}
</style>
